/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';
import { NodePath } from '../../core/models/NodePath';
import { IServerParent } from '../../core/models/common/IServerParent';
import { Server } from '../../core/models/common/Server';
import { MarshallCompat } from '../../compat/MarshallCompat';
import { Node } from '../../core/models/Node';
import { ServerVariable } from '../../core/models/common/ServerVariable';

/**
 * A command used to modify a server.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class ChangeServerCommand extends AbstractCommand {
    public _parentPath : NodePath;

    public _serverUrl : string;

    public _serverObj : any;

    public _oldServer : any;

    public constructor(server? : any) {
        if(((server != null && server instanceof <any>Server) || server === null)) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._serverUrl===undefined) this._serverUrl = null;
            if(this._serverObj===undefined) this._serverObj = null;
            if(this._oldServer===undefined) this._oldServer = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._serverUrl===undefined) this._serverUrl = null;
            if(this._serverObj===undefined) this._serverObj = null;
            if(this._oldServer===undefined) this._oldServer = null;
            (() => {
                this._parentPath = Library.createNodePath(server.parent());
                this._serverUrl = server.url;
                this._serverObj = Library.writeNode(server);
            })();
        } else if(server === undefined) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._serverUrl===undefined) this._serverUrl = null;
            if(this._serverObj===undefined) this._serverObj = null;
            if(this._oldServer===undefined) this._oldServer = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._serverUrl===undefined) this._serverUrl = null;
            if(this._serverObj===undefined) this._serverObj = null;
            if(this._oldServer===undefined) this._oldServer = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[ChangeServerCommand] Executing.");
        this._oldServer = null;
        let parent : IServerParent = <IServerParent><any>this._parentPath.resolve(document);
        if(this.isNullOrUndefined(parent)) {
            return;
        }
        let server : Server = parent.getServer(this._serverUrl);
        if(this.isNullOrUndefined(server)) {
            return;
        }
        this._oldServer = Library.writeNode(server);
        this.replaceServerWith(server, this._serverObj);
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[ChangeServerCommand] Reverting.");
        if(this.isNullOrUndefined(this._oldServer)) {
            return;
        }
        let parent : IServerParent = <IServerParent><any>this._parentPath.resolve(document);
        if(this.isNullOrUndefined(parent)) {
            return;
        }
        let server : Server = parent.getServer(this._serverUrl);
        if(this.isNullOrUndefined(server)) {
            return;
        }
        this.replaceServerWith(server, this._oldServer);
    }

    /**
     * Replaces the content of a server with the content from another server.
     * @param {Server} toServer
     * @param {*} fromServer
     */
    replaceServerWith(toServer : Server, fromServer : any) {
        toServer.getServerVariables().forEach((var_) => {
            toServer.removeServerVariable(var_.getName());
        });
        Library.readNode(fromServer, toServer);
    }
}
ChangeServerCommand["__class"] = "io.apicurio.datamodels.cmd.commands.ChangeServerCommand";
ChangeServerCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




